module.exports = __webpack_public_path__ + "img/404-penguin.75439c24.svg";